import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { OrderService } from "../../services/order/order.service";
import { PATH_STEP_2 } from "../../app-routing.constants";

@Injectable()
export class Step3Guard implements CanActivate {

    constructor(
        public router: Router,
        public orderService: OrderService,
    ) {
        //
    }

    canActivate(): boolean {
        if (!this.orderService.order.step2Completed) {
            this.router.navigate([PATH_STEP_2], { replaceUrl: true });
            return false;
        }
        return true;
    }

}
